import React, { useState } from 'react';
import './Footer.css';
import { WhatsApp } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import Termsofuse from './Termsofuse'; // ✅ Import Terms of Use page
import PrivacyPolicy from './PrivacyPolicy'; // ✅ Import Privacy Policy page

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // If we're not on the home page, navigate to home first
    if (window.location.pathname !== '/') {
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const section = document.getElementById(sectionId);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // We're on the home page, just scroll
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsOpen(false);
  };

  const handlePageNavigation = (path) => {
    // Scroll to top when navigating to any page
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(path);
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Company Info Section */}
        <div className="footer-section company-info">
          <h4>MindSpace Health</h4>
          <p>Providing compassionate virtual psychiatry services across Michigan and California. Your mental health journey starts here.</p>
          <div className="contact-info">
            <p><strong>Email:</strong> mindspace@mindspacellc.com</p>
            <p><strong>Phone:</strong> Available through patient portal</p>
          </div>
        </div>

        {/* Quick Links Section */}
        <div className="footer-section quick-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('hero'); }}>Home</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About Us</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Our Services</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('newPatients'); }}>New Patients</a></li>
            <li><a href="#" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact Us</a></li>
          </ul>
        </div>

        {/* Services Section */}
        <div className="footer-section services">
          <h4>Our Services</h4>
          <ul>
            <li>Depression Treatment</li>
            <li>Anxiety Management</li>
            <li>Bipolar Disorder Care</li>
            <li>ADHD Treatment</li>
            <li>PTSD Therapy</li>
            <li>OCD Support</li>
          </ul>
        </div>

        {/* Hours & Legal Section */}
        <div className="footer-section hours-legal">
          <h4>Availability</h4>
          <div className="hours">
            <p><strong>Michigan:</strong><br />Monday - Sunday<br />1 pm to 9 pm (EST)</p>
            <p><strong>California:</strong><br />Monday - Sunday<br />10 am to 7 pm (PST)</p>
          </div>

          <div className="legal-links">
            <h5>Legal</h5>
            <ul>
              <li><Link to="/terms-of-use" onClick={() => window.scrollTo(0, 0)}>Terms of Use</Link></li>
              <li><Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; 2025 MindSpace Health Services. All rights reserved.</p>
          <p className="disclaimer">Virtual psychiatry services available in Michigan and California only.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
